import { string, object, node, oneOf, bool } from 'prop-types';
import React, { useState, useRef } from 'react';
import useOutsideClick from '../../hooks/use-outside-click';
import setClass from '../../common/set-class';
const defaultPositionStyle = {
    bottom: { top: '50px' },
    left: { right: '50px' },
    right: { left: '50px' },
    top: { bottom: '50px' },
};
const Menu = ({ className, menuClassName, style, menuStyle, children, position, isDisabled, positionStyle, preventDefault, }) => {
    const triggerRef = useRef();
    const menuRef = useRef();
    const [isShowing, setIsShowing] = useState(false);
    useOutsideClick(triggerRef, (e) => {
        if (!e.composedPath().includes(menuRef.current)) {
            setIsShowing(false);
        }
    });
    const arrChildren = React.Children.toArray(children);
    const options = arrChildren[0];
    const trigger = arrChildren[1];
    return (React.createElement("div", { className: className, style: { ...style, position: 'relative' } },
        trigger &&
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            React.cloneElement(trigger, {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'props' does not exist on type 'ReactChil... Remove this comment to see the full error message
                ...trigger.props,
                onClick: (e) => {
                    if (!isDisabled) {
                        e.preventDefault();
                        setIsShowing(true);
                    }
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'props' does not exist on type 'ReactChil... Remove this comment to see the full error message
                    if (trigger.props.onClick) {
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'props' does not exist on type 'ReactChil... Remove this comment to see the full error message
                        trigger.props.onClick(e);
                    }
                },
                ref: triggerRef,
            }),
        isShowing && (React.createElement("div", { 
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
            ref: menuRef, className: setClass(['b-menu', menuClassName || '']), style: {
                ...menuStyle,
                position: 'absolute',
                ...positionStyle[position],
                zIndex: 999,
            } }, React.Children.map(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'props' does not exist on type 'ReactChil... Remove this comment to see the full error message
        options.props.children, (child) => child &&
            React.cloneElement(child, {
                ...child.props,
                onClick: (e) => {
                    if (preventDefault) {
                        e.preventDefault();
                    }
                    if (child.props.onClick) {
                        child.props.onClick(e);
                    }
                    setIsShowing(false);
                },
                className: setClass('b-txt btn-icon', child.props && child.props.className
                    ? child.props.className
                    : 'b-btn-action-link default'),
            }))))));
};
Menu.propTypes = {
    className: string,
    menuClassName: string,
    style: object,
    menuStyle: object,
    children: node,
    position: oneOf(['top', 'right', 'bottom', 'left']),
    isDisabled: bool,
    positionStyle: object,
    preventDefault: bool,
};
Menu.defaultProps = {
    className: '',
    style: {},
    menuClassName: '',
    menuStyle: {},
    children: React.createElement(React.Fragment, null),
    position: 'bottom',
    isDisabled: false,
    positionStyle: defaultPositionStyle,
    preventDefault: true,
};
export default Menu;
